import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21d5bc58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"font-size":"2rem"} }

import { computed, ref } from "vue";
import FetchRequest from "@/api/FetchRequest";


export default /*#__PURE__*/_defineComponent({
  __name: 'Avatar',
  props: {
  size: {
    type: String,
    required: false,
    default: "default",
  },
  img: {
    type: String,
    required: true,
    default: "@/assets/icon.png",
  },
  name: {
    type: String,
    required: false,
    default: "",
  },
},
  setup(__props) {

const props = __props;

const host = ref(FetchRequest.getHost());

let url = computed(() => {
  if (props.img?.indexOf("http") > -1) {
    return props.img;
  } else if (props.img?.trim() === "") {
    return null;
  } else {
    return host.value + props.img;
  }
});
let start = computed(() => {
  return props.name ? props.name[0] : "";
});

return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(url))
      ? (_openBlock(), _createBlock(_component_el_avatar, {
          key: 0,
          shape: "square",
          size: __props.size,
          src: _unref(url),
          fit: "cover"
        }, null, 8, ["size", "src"]))
      : _createCommentVNode("", true),
    (!_unref(url))
      ? (_openBlock(), _createBlock(_component_el_avatar, {
          key: 1,
          shape: "square",
          size: __props.size,
          fit: "cover"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(start)), 1)
          ]),
          _: 1
        }, 8, ["size"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})